export default __webpack_public_path__ + "static/media/dev-python-flesk-api.51de217c.png";